module.exports = __webpack_public_path__ + "static/media/1_Protocol-Formoplast-OSA-20150925.ae16450f.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2015/1_Protocol-Formoplast-OSA-20150925.pdf
// module id = 175
// module chunks = 0